import { enUS as en, ru } from 'date-fns/locale';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { CalendarToday } from '@mui/icons-material';
import { DateField, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { withControl } from '@features/effector-form/hoc/withControl';
import { getSafePickerLocale } from '@shared/utils/getSafePickerLocale';
import { theme } from '@unicorn/bms-theme';

type Props = {
  sx?: object;
  sxForm?: object;
};

const EN = 'en';
const LNG = localStorage.getItem('lang') || EN;

export const DateControl = withControl<Props>(
  ({
    value,
    setValue,
    error,
    label,
    required,
    readOnly,
    disabled,
    sx = {},
    sxForm = {},
    isError,
  }) => (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={LNG === EN ? en : ru}
      localeText={getSafePickerLocale(LNG)}
    >
      <FormControl required={required} disabled={disabled} sx={sxForm}>
        {label && <FormLabel error={isError}>{label}</FormLabel>}
        <DateField
          value={value}
          onChange={(newValue) => setValue(newValue)}
          InputProps={{
            readOnly,
            disabled,
            error: isError,
            endAdornment: <CalendarToday sx={{ color: theme.palette.action.active }} />,
          }}
          readOnly={readOnly}
          disabled={disabled}
          sx={sx}
          size="small"
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
      </FormControl>
    </LocalizationProvider>
  )
);
